<template>
  <div>
    <v-navigation-drawer
      style="position: fixed; z-index: 2; border-radius: 2px; margin-top: 70px"
      dark
      color="#000000"
      height="100%"
      v-model="localDrawer"
      absolute
      temporary
    >
      <MenuItems :drawer-state="localDrawer" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import MenuItems from './MenuItems'

export default {
  name: 'MenuMobile',
  components: { MenuItems },
  props: {
    show: {},
    drawer: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      localDrawer: this.drawer
    }
  },
  watch: {
    drawer (newVal) {
      this.localDrawer = newVal
    },
    localDrawer (newVal) {
      this.$emit('update:drawer', newVal)
    }
  },
  methods: {
    can (val) {
      return this.$can(val)
    }
  }
}
</script>

<style lang="scss">
.v-list-item--active {
  i {
    color: #f4c20c !important;
    opacity: 0.8;
  }
}
html.overflow-y-hidden {
  overflow-y: scroll !important;
}
.v-overlay__scrim {
  z-index: -9999 !important;
}
</style>
